export const MAX_IMAGE_WIDTH = 250;
export const ASPECT_RATIO = 0.75;
export const SOLD_OUT = 'Sold Out';
export const IMAGE_CARD_CLICKED = 'plp_imagecard_click';
